import { User, Users, Bookmark, LogOut, CreditCard, FileText, Settings, KeyRound, Tv2 } from "lucide-react";

export interface DropdownItem {
  href?: string;
  label: string;
  icon: React.ReactNode;
  active: boolean;
}


export function buildDropdownItems(displayName: string): DropdownItem[] {
  return [
    { href: "/account", label: displayName, icon: <User />, active: false },
    { href: "/account", label: "مدیریت اعضا", icon: <Users />, active: false },
    { href: "/account/bookmarks", label: "نشان شده‌ها", icon: <Bookmark />, active: false },
    { href: "/account/subscription", label: "اشتراک من", icon: <Tv2 />, active: false },
    { href: "/account/invoices", label: "پرداخت‌ها", icon: <CreditCard />, active: false },
    { href: "/account/devices", label: "دستگاه‌های من", icon: <FileText />, active: false },
    { href: "/account/chengepassword", label: "تغییر رمز عبور", icon: <KeyRound />, active: false },
    { href: "/account/plans", label: "خرید اشتراک", icon: <Settings />, active: false },
    { label: "خروج از حساب", icon: <LogOut />, active: false },
  ];
}
